import React from "react";
import { useWatchState, handler, useModal } from "@/store";
import { Avatar, Logo } from "@/components";
import { avatar } from "@/common";
import logo from "./images/push-logo.png";
import { Dropdown, Menu } from "antd";
import logoDark from "./images/push_logo_dark.png";
import "./style.less";
import { Link } from "react-router-dom";

function CourseHead({ theme = "hight", className = "" }) {

    const [[UPLOAD_SERVER_HOST = ""]] = useWatchState(["$_UPLOAD_SERVER_HOST"]);
    const [[{ IS_LOGIN, info = {} }]] = useWatchState(["user"])
    const [userSetModal] = useModal(["userSet"])

    const menu = (
        <Menu>
            <Menu.Item>
                <span onClick={userSetModal.show.later({ UPLOAD_SERVER_HOST })}>账号设置</span>
            </Menu.Item>
            <Menu.Item>
                <span onClick={handler.logout}>退出登录</span>
            </Menu.Item>
        </Menu>
    );

    return (
        <header className={`module-commonHead module-commonHead--${theme} flex ver between ${className}`}>
            <Logo theme={theme} />
            <div className="flex ver child-left-md">
                <Link className="link" to="/">首页</Link>
                {IS_LOGIN
                    ? <div className="child-left-sm flex ver">
                        <Dropdown className="child-left-md" overlay={menu}>
                            <a className="link">{info.nickname || info.account}</a>
                        </Dropdown>
                        <Avatar width="30px" url={avatar(info.avatar, UPLOAD_SERVER_HOST)} className="border-white" />
                    </div>
                    : <div className="child-left-sm">
                        <Link to="/login">登录</Link>
                        <span>|</span>
                        <Link to="/register">新用户注册</Link>
                    </div>}
            </div>
        </header>
    )
}

export default CourseHead;
